import { SitesGridView } from '~/components/system/sites';
import { PageContainer } from '~/components/page-container';

export function Sites() {
	return (
		<PageContainer>
			<SitesGridView />
		</PageContainer>
	);
}
